// @flow

/* eslint-disable ta-code-conventions/has-matching-storydoc */

import * as React from 'react';
import { connect } from 'react-redux';

import Link from './Link';
import type { Props as LinkProps } from './Link';

type Props = {|
  ...LinkProps,
  /** Target to be used for mobile devices only. Falls back to target property */
  mobileTarget?: '_self' | '_blank',
|};

type InternalProps = {|
  ...Props,
  viewportCategory: string,
|};

/**
 * Displays a Link which allows the specification of a different target for mobile devices.
 * This is useful for the common situation where links should be opened in the same tab for mobile and a new tab on Desktop, or vice versa.
 *
 */
const ResponsiveTargetLink = ({ mobileTarget, viewportCategory, ...linkProps }: InternalProps) => {
  const target = viewportCategory === 'MOBILE' && mobileTarget ? mobileTarget : linkProps.target;

  return <Link {...linkProps} target={target} />;
};

// $FlowFixMe - Need this because activeClassName and className are required props of Link, even though they probably shouldn't be
export default connect(state => ({
  viewportCategory: state.meta.device.viewportCategory,
}))(ResponsiveTargetLink);
